<template>
    <div class="loginbox" :style="{height: pageHeight + 'px'}">
      <div v-show="showLogin">
        <div class="titcontent">
         <h1>
            <img src="../assets/px-fanbai.png" alt="">
            <span>配网智能决策系统</span>
          </h1>
       </div>
        <!-- 手机号，验证码输入区域 -->
        <div class="input-content">
            <div class="input-item">
                <field v-model="phone" label-align="center" maxlength="11" clearable placeholder="请输入手机号">
                </field>
            </div>
            <div class="input-item input-item-2">
                <field v-model="psw" label-align="center" minlength="6" clearable type="password" placeholder="请输入密码"></field>
            </div>

            <div>
                <a href="javascript:;" class="btn" :class="{active: btnClickAble}" @click="onBtnClick">登录</a>
                <span style="float:right;margin-top:10px;" @click="toforgetPSW">忘记密码</span>
                <p style="margin-top: 12vh;text-align:center;color:#0B7DEC" @click="toregister">用户注册</p>
            </div>
        </div>
      </div>
      <div v-show="!showLogin">
        <div class="titcontent">
         <h1>
            <img src="../assets/logo-zcy@3x.png" alt="">
            <span>配网智能决策系统</span>
          </h1>
       </div>
        <!-- 手机号，验证码输入区域 -->
        <div class="input-content">
            <div class="input-item">
                <field v-model="phoneRegister" label-align="center" maxlength="11" clearable placeholder="请输入手机号">
                  <!-- <template #button>
                        <a href="javascript:;" @click="next" style="color: #0B7DEC;">{{nextBtnTxt}}</a>
                    </template> -->
                </field>
            </div>
            <div class="input-item input-item-2">
                <field v-model="vscode" label-align="center" maxlength="6" placeholder="请输入验证码">
                    <template #button>
                        <a href="javascript:;" @click="sendVscode" style="color: #0B7DEC;border: 1px solid #0B7DEC;border-radius: 16px;padding: 3px 8px;">{{smsBtnTxt}}</a>
                    </template>
                </field>
            </div>
            <div class="input-item input-item-2">
                <field v-model="pswRegister" label-align="center" minlength="11" clearable placeholder="请输入至少6位数的密码"></field>
            </div>

            <div>
                <a href="javascript:;" class="btn" :class="{active: btnClickAble1}" @click="onBtnRegister">注册</a>
                <p style="margin-top: 12vh;text-align:center;color:#0B7DEC" @click="tologin">用户登录</p>
            </div>
            <!-- 占位div -->
            <!-- <div style="height:15vh;"></div> -->
        </div>
      </div>

    </div>
</template>

<script>
import { Field } from 'vant'

export default {
  name: 'login',
  components: { Field },
  created () {
    // console.log(this.phone)
    // console.log(this.psw)
  },
  activated () {
    console.log('activated')
    // this.phone = ''
    // this.psw = ''
  },
  mounted () {
    // console.log('mounted')
  },
  methods: {
    // 点击确认
    onBtnClick () {
      if (!this.phone) {
        this.util.toast('请输入手机号码')
        return
      }
      // 不合法的手机号码
      if (!this.util.isPhoneNumber(this.phone)) {
        this.util.toast('请输入正确手机号码')
        return
      }

      if (!this.psw || this.psw.length < 6) {
        this.util.toast('请输入正确密码')
        return
      }

      // 请求验证接口：
      this.util.post('/login', {
        phoneNum: this.phone,
        passWord: this.psw,
        token: localStorage.getItem('loginToken'),
        devicetype: localStorage.getItem('loginDevicetype')
      }).then(({ data }) => {
        if (data.code === 200) {
          // 登录按钮执行登录的时候，存localStorage
          localStorage.setItem('isLogin', 1) // 存储已登录信息
          localStorage.setItem('UserToken', data.data.UserToken)
          localStorage.setItem('phoneNum', this.phone) // 存储手机号
          localStorage.setItem('passWord', this.psw) // 存储密码
          if (data.data.status === 1) {
            // 不是第一次登录，跳转到主页
            this.$router.replace({
              path: '/home',// 进入主页
              query:{date:new Date().getTime()}
            })
          } else {
            // 验证成，跳转首页
            this.$router.replace({
              path: '/guide'// 进入引导页
            })
          }
        } else {
          // 验证失败
          return this.util.toast(data.msg)
        }
      })
    },

    toforgetPSW () {
      this.$router.push({
        path: '/forgetPSWPage'// 到忘记密码页
      })
    },
    toregister () {
      // this.$router.replace({
      //   path: '/register'// 进入注册页
      // })
      this.showLogin = false
    },
    // 发送验证码
    sendVscode () {
      // 如果正在倒计时，不能继续发送。
      if (this.smsBtnTxt !== '获取验证码') { return }

      // 不合法的手机号码
      if (!this.phoneRegister) {
        this.util.toast('手机号码不能为空')
        return
      }
      if (!this.util.isPhoneNumber(this.phoneRegister)) {
        this.util.toast('请输入正确手机号码')
        return
      }

      // 请求发短信接口。
      this.util.post('/loginVerificationCode', {
        phoneNum: this.phoneRegister
      }).then(({ data }) => {
        if (data.code === 200) {
          this.util.toast(data.msg)
          // 开始倒计时。
          this.startTimeDown(60)
        } else {
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    // 点击确认
    onBtnRegister () {
      if (!this.phoneRegister) {
        this.util.toast('请输入手机号码')
        return
      }
      // 不合法的手机号码
      if (!this.util.isPhoneNumber(this.phoneRegister)) {
        this.util.toast('请输入正确手机号码')
        return
      }

      if (!this.vscode || this.vscode.length < 6) {
        this.util.toast('请输入正确验证码')
        return
      }
      if (!this.pswRegister) {
        this.util.toast('请输入正确密码')
        return
      }

      // 请求验证接口：
      this.util.post('/loginRegister', {
        phoneNum: this.phoneRegister,
        verificationCode: this.vscode,
        passWord: this.pswRegister
      }).then(({ data }) => {
        if (data.code === 200) {
          // 登录按钮执行登录的时候，存localStorage
          localStorage.setItem('isLogin', 1) // 存储已登录信息
          localStorage.setItem('UserToken', data.data.UserToken)
          this.showLogin = true
        } else {
          // 验证失败
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },

    // 倒计时
    startTimeDown (time) {
      let current = time
      let fun = () => {
        current--
        if (current <= 0) {
          this.smsBtnTxt = '获取验证码'
        } else {
          this.smsBtnTxt = current + ' 秒后重新获取'
          setTimeout(fun, 1000)
        }
      }

      fun()
    },
    tologin () {
      // this.$router.replace({
      //   path: '/login'// 进入登录页
      // })
      this.showLogin = true
    }
  },
  computed: {
    btnClickAble () {
      return this.util.isPhoneNumber(this.phone) && this.psw && this.psw.length >= 1
    },
    btnClickAble1 () {
      return this.util.isPhoneNumber(this.phoneRegister) && this.vscode && this.vscode.length >= 1
    }
  },
  data () {
    return {
      showLogin: true,
      pageHeight: window.innerHeight,
      phone: '', // 用户输入的电话号码。
      psw: '', // 用户输入的密码。
      // token: '',
      // devicetype: ''
      nextBtnTxt: '下一步', // 下一步的提示文案。
      smsBtnTxt: '获取验证码', // 发送验证码的提示文案。
      phoneRegister: '', // 用户输入的电话号码。
      vscode: '', // 用户输入的短信验证码。
      pswRegister: '' // 用户密码。
    }
  }
}
</script>

<style scoped lang="less">
    .loginbox {
      width: 100vw;
      background: #fff;
        .titcontent{
           height: 30vh;
          width: 100vw;
          background: linear-gradient(227deg, #06C8B5 0%, #007CF8 100%);
          display: flex;
          /*实现垂直居中*/
          align-items: center;
          /*实现水平居中*/
          justify-content: center;
          text-align: justify;
        }
        h1{
          text-align: center;
          font-size: 20px;
          letter-spacing: 2px;
          span{
            color: #FFFFFF;
            display: block;
          }
          img{
            width: auto;
            height: 8vh;
            margin-right: 10px;
          }
        }
    }

    .input-content {
        width: 75%;
        margin: 20px auto;
    }

    .input-item-2 {
        margin-top: 20px;
    }

    .btn {
        display: block;
        background-color: #0B7DEC;
        color: #fff;
        font-size: 16px;
        text-align: center;
        padding: 12px 0;
        border-radius: 25px;
        margin-top: 25px;
    }

    .btn.active {
          background-color: rgb(20, 146, 227);
          color: #fff;
    }

    .van-cell {
        border-bottom: 1px solid #EBEBEB;
    }
</style>
